var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.014 14.601l-3.571-1.53a1.613 1.613 0 00-1.877.46l-1.15 1.406a10.935 10.935 0 01-4.366-4.363l1.406-1.15a1.614 1.614 0 00.46-1.878l-1.528-3.569a1.604 1.604 0 00-1.839-.935l-3.311.763A1.603 1.603 0 003.99 5.373c0 8.658 7.02 15.63 15.629 15.627a1.603 1.603 0 001.567-1.248l.763-3.313a1.609 1.609 0 00-.935-1.838zm-1.462 4.715c-7.65-.036-13.84-6.226-13.875-13.88l3.189-.734 1.48 3.453-2.394 1.958c1.63 3.48 3.452 5.296 6.925 6.926l1.958-2.395 3.452 1.48-.735 3.192z",
    fill: "#777"
  })));
}

export default SvgPhoneAlt;